.container {
  border: 1px solid var(--dialog-border);
  background-color: var(--main-background);
  box-shadow: 0 0 30px 0 var(--shadow);
}
